import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import Layout from "@/components/layout/Layout";

const Contact = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="py-16 md:py-24 bg-secondary">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-playfair font-semibold text-cream mb-4">
              Let's Discuss Your Ceremony
            </h1>
            <p className="text-xl text-cream/80">
              I'd love to hear about your wedding and help you choose the perfect ceremony music.
            </p>
          </motion.div>
        </div>
      </section>

      {/* WhatsApp Primary CTA */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-2xl font-playfair font-semibold text-secondary mb-4">
              The Quickest Way to Reach Me
            </h2>
            <p className="text-secondary/70 mb-6">
              Send me a WhatsApp message with your wedding date, venue, and ceremony time. I'll respond within 24 hours.
            </p>
            <a
              href="https://wa.me/447702696253?text=Hi%20Olivia%2C%20I'm%20interested%20in%20ceremony%20music%20for%20my%20wedding.%0A%0AWedding%20date%3A%0AVenue%3A%0ACeremony%20time%3A"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-600 text-white px-8 py-4 rounded-md font-medium text-lg hover:bg-green-700 transition-all"
            >
              <FaWhatsapp className="w-5 h-5" />
              Message Me on WhatsApp
            </a>
            <p className="text-secondary/60 text-sm mt-4">
              Available for wedding ceremonies within 25 miles of Sutton Coldfield.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Alternative Contact Methods */}
      <section className="py-12 bg-cream/50">
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-center text-secondary/60 text-sm mb-6">Or contact me via:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <motion.a
              href="tel:+447702696253"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="flex items-center justify-center gap-3 p-4 bg-white rounded-lg hover:bg-cream transition-colors"
            >
              <Phone className="w-5 h-5 text-primary" />
              <span className="text-secondary">07702 696 253</span>
            </motion.a>
            
            <motion.a
              href="mailto:hello@oliviaflemming.co.uk"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="flex items-center justify-center gap-3 p-4 bg-white rounded-lg hover:bg-cream transition-colors"
            >
              <Mail className="w-5 h-5 text-primary" />
              <span className="text-secondary">hello@oliviaflemming.co.uk</span>
            </motion.a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;